import React from 'react';

import Page from 'components/page';
import SolutionTemplate from 'components/solutionTemplate';
import { CTAS } from 'context/solutions/constants';

const sections = [
  {
    title: 'WorkBench',
    image: 'products/workbench.jpg',
    ctas: [CTAS.READ_MORE, CTAS.REQUEST_DEMO],
    description: `
      WorkBench is an integrated ERP, designed for agriculture value chain 
      management. Service providers with field officers can utilize the 
      software to manage the entire value chain operations from input sourcing 
      and sales, to loan administration and repayment, payment and financials.  
      It's specially designed to fit the nature of the Nigerian environment, 
      where farms are in remote off-grid rural communities and farms also small 
      and fragmented.`,
  },
  {
    title: 'AFEX Commodities Index (ACI)',
    ctas: [CTAS.READ_MORE, CTAS.START_TRADING],
    image: 'products/AFEX-commodities-index.jpg',
    description: `
      The AFEX Commodities Index (ACI) is designed to provide an avenue to track 
      prices of commodities in Nigeria, create an investment class for savvy investors 
      and those seeking exposure to the commodities market as well as reflect 
      physical commodity dynamics. The construction of the index is based on a 
      quantitative methodology leveraging on the liquid securities to be included.`,
  },
];

const BigDataAnalytics = () => {
  return (
    <Page pageName="bigDataAnalytics">
      <SolutionTemplate sections={sections} />
    </Page>
  );
};

export default BigDataAnalytics;
